import React from 'react';
import { Dialog } from 'primereact/dialog';
import { FormBacterium } from './FormBacterium';
import { Button } from 'reactstrap';


export const ModalBacterium = (props) => {

    const {
        modal, closeDialog, modalTitle, method,
        validaciones,
        bacterium, gram, id_mic_morphology, morphologys,
        antibiograms, antibiogramsSelected, onChangeAntibiogram,
        handleInputChange, loading,
        saveCreate, saveUpdate,
        stainGrams, id_mic_stain_gram,
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            blockScroll
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-tablets f-24"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-medium3`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando Bacteria...." : "Crear Bacteria"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdate}
                        >
                            {
                                loading ? "Actualizando Bacteria...." : "Actualizar Bacteria"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}>
                        Cancelar
                    </Button>
                </>
            }
        >
            {
                method === "create"
                    ? (
                        <FormBacterium
                            button="Crear bacteria"
                            {...{
                                loading, handleInputChange, validaciones,
                                methodAction: saveCreate,
                                morphologys, antibiograms, antibiogramsSelected,
                                onChangeAntibiogram,
                                stainGrams, id_mic_stain_gram,
                                closeDialog
                            }}
                        />
                    )
                    : method === "update"
                        ? (
                            <FormBacterium
                                button="Actualizar bacteria"
                                {...{
                                    loading, handleInputChange, validaciones,
                                    methodAction: saveUpdate,
                                    bacterium, gram, id_mic_morphology,
                                    morphologys, antibiograms, antibiogramsSelected,
                                    onChangeAntibiogram,
                                    stainGrams, id_mic_stain_gram,
                                    closeDialog
                                }}
                            />
                        )
                        : null
            }
        </Dialog>
    );
};
